import { render, staticRenderFns } from "./ReadOnlyTable.vue?vue&type=template&id=71160360&scoped=true&"
import script from "./ReadOnlyTable.vue?vue&type=script&lang=js&"
export * from "./ReadOnlyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71160360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71160360')) {
      api.createRecord('71160360', component.options)
    } else {
      api.reload('71160360', component.options)
    }
    module.hot.accept("./ReadOnlyTable.vue?vue&type=template&id=71160360&scoped=true&", function () {
      api.rerender('71160360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/modules/JEditableTable/ReadOnlyTable.vue"
export default component.exports